module.exports = __webpack_public_path__ + "images/ai_recommendations/thumbs_up-b6f73c0c9f2d2a4152f361ae92c871b1.svg";